/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityHarvestDto } from '../../models/facility-harvest-dto';

export interface GetFacilityHarvests$Params {
  facilityId: number;
  filterDate?: string;
}

export function getFacilityHarvests(http: HttpClient, rootUrl: string, params: GetFacilityHarvests$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityHarvestDto>>> {
  const rb = new RequestBuilder(rootUrl, getFacilityHarvests.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.query('filterDate', params.filterDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FacilityHarvestDto>>;
    })
  );
}

getFacilityHarvests.PATH = '/api/facility/{facilityId}/harvest';
